import localForage from "localforage";
const KEY = "editorData";

// Returns whole DB
export const getDB = async () => {
    try {
        return JSON.parse(await localForage.getItem(KEY));
    } catch (err) {
        console.log(err);
        return null;
    }
}

// Updates DB
export const updateDB = async (post) => {
    try {
        await localForage.setItem(KEY, JSON.stringify(post));
    } catch (err) {
        console.log(err);
    }
}